import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Te despiertas a las 3 am y tu mente no para de dar vueltas.', 'Amaneces agotada, como si no hubieras dormido en toda la noche.', 'Sientes que tu cuerpo cambió y te cuesta conciliar el sueño.', 'Te sientes sin energía durante el día y dependes del café para funcionar.', 'Has probado tés, pastillas y meditaciones, pero sigues sin descansar profundamente.'];
export function PainSection() {
  return <section className="bg-warm-white pt-4 pb-16 md:py-24 px-4" data-id="element-191">
      <div className="max-w-3xl mx-auto" data-id="element-192">
        {/* Intro text block */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-193">
          <p className="text-lg md:text-xl font-heading font-semibold text-olive leading-snug" data-id="element-194">
            Si no duermes bien...tu cuerpo no puede repararse ni desinflamarse.
          </p>
          <p className="text-base md:text-lg text-warm-gray mt-2 leading-snug" data-id="element-195">
            Este método te enseñará cómo comenzar a regular tu sueño desde la
            raíz, entendiendo tus hormonas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-196">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-olive" data-id="element-197">
            ¿Te está pasando esto después de los 40?
          </h2>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-198">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-start gap-4 bg-white p-5 rounded-2xl shadow-card" data-id="element-199">
              <div className="mt-1.5 w-3 h-3 rounded-full bg-warm-accent flex-shrink-0" data-id="element-200" />
              <p className="text-olive font-medium text-lg" data-id="element-201">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center space-y-2 bg-cream p-8 rounded-2xl border border-sage/20" data-id="element-202">
          <p className="text-xl md:text-2xl font-bold text-olive font-heading" data-id="element-203">
            No es insomnio por estrés normal.
          </p>
          <p className="text-lg md:text-xl font-bold text-sage" data-id="element-204">
            Son cambios hormonales y de cortisol que casi nadie te explicó.
          </p>
        </motion.div>
      </div>
    </section>;
}